import axios from "axios";

const fetchBillsWithSponsors = async (billsData) => {
    const limit = 150;
    let sponsorsData = [];
    let currentPage = 0;
    let totalPages = 1;
    try {
        while (currentPage < totalPages) {
            const sponsorIds = billsData.map(bill => bill.sponsorId);
            const response = await axios.post(
                `${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/legislators/search?limit=${limit}&offset=${currentPage}`,
                {legislatorIds: sponsorIds}
            )
            const currentPageSponsorData = response.data;
            sponsorsData = sponsorsData.concat(currentPageSponsorData.content || []);
            totalPages = currentPageSponsorData.totalPages;
            currentPage++;
        }
        return billsData.map((bill) => ({
            ...bill,
            sponsor: sponsorsData[sponsorsData.findIndex((sponsor) =>
                sponsor.id === bill.sponsorId)] || {}
        }));
    } catch (error) {
        console.error(`Error fetching sponsors`, error);
        throw error;
    }
};

export default fetchBillsWithSponsors;